class SectionHero extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.section = this.querySelector("[data-text]");
    this.sectionNav = this.querySelector("[data-hero-navigation]");
    this.initFunction();
  }

  initFunction() {
    this.sectionNav &&
      this.sectionNav.addEventListener("click", (e) => {
        const nextSection = this.parentNode.nextElementSibling;
        nextSection && nextSection.scrollIntoView({ behavior: "smooth" });
      });
  }
}

if (!customElements.get("section-hero")) {
  customElements.define("section-hero", SectionHero);
}
